export const SET_FRIENDS = "SET_FRIENDS";
export const SET_MESSAGES_FRIEND = "SET_MESSAGES_FRIEND";
export const SET_PROFILE = "SET_PROFILE";
export const SET_TOKEN = "SET_TOKEN";
export const SET_SOCKET = "SET_SOCKET";
